
$( () => {
  $('.custom-radio-input').change(function(){
    $(this).closest('.custom-radio-options-group').find('.custom-radio-container').removeClass("selected");
    $(this).closest('.custom-radio-container').addClass("selected");
  });
});